<template>
    <div :id="siteDisplay" v-cloak>
        <vue-headful :head="{'link[rel=icon]': {href: faviconURL}}"/>
        <router-view :key="$route.fullPath" :name="template"/>
        <!-- セッション切れ -->
        <alert-Confirm v-if="alertSessionMes.showMes"
            :msgConfirm="alertSessionMes.message"
            :okAction="doNextUrl"
            :isButtonCancel="alertSessionMes.isButtonCancel"
            :cancelAction="doNextUrl"
        />
    </div>
</template>

<script>
/* 
* Import libs and componnents
*/
import SiteConstants from 'assets/const/SiteConstants.json';
import EventBus from 'assets/js/eventBus';
import $ from 'jquery';
import 'assets/css/icon.css';
import common from "assets/js/common";
import AlertConfirm from '../../components/AlertConfirm.vue';

export default {
    /* 
    * Name of component
    */
    name: "template2",
    /* 
    * Declare props
    */
    props: {
        template: String,
    },
    components:{
      AlertConfirm  
    },
    /* 
    * Declare variable and set default value
    */
    data() {
        return {
            isLogin: false,
            site: "",
            siteDisplay: "",
            faviconURL: "/favicon.ico",
            pg010MainRequest:{},
            pg010MainCss:{
                titleNm: null,
                siteText: null,
                siteTag: null,
                pgColor: null,
                linkColor: null,
                overLinkColor: null,
                pgImg: null,
                keyWords: '',
                noIndexFlg : 0
            },
            alertSessionMes:{
                showMes:false,
                message:'一定時間操作がなかったため、セッションが終了しました。<br> お手数をおかけしますが、再度ログインのうえご利用ください',
                isButtonCancel:false,
                nextUrl:''
            }
            
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        var _faviconURL = "";
        var _cssURL = "";
        var _cssFolderName = "";
        var _jsURL = "";
        var _jsFolderName = "";
        var _latest = Math.random();

        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        _this.$i18n.locale = _this.site;

        var url = location.href.replace("5500","4000").split("/");
        if (process.env.NODE_ENV != 'development'){
            url = location.href.split("/");
        }
        _cssURL = (process.env.NODE_ENV === 'development') ? _this.$i18n.t('css.url.develop') : _this.$i18n.t('css.url.production');
        if(_cssURL != undefined) {
            _cssURL = url[0]+"//"+url[2]+"/"+_cssURL;
            _cssFolderName = _this.$i18n.t('css.name');
            _this.siteDisplay = _cssFolderName;

            if (!_cssURL.endsWith('/')) {
                _cssURL += '/';
            }
            $('head').append($('<link type="text/css" rel="stylesheet">').attr('href',_cssURL + _cssFolderName + 'style.css?t=' + _latest));
        }

        _jsURL = (process.env.NODE_ENV === 'development') ? _this.$i18n.t('js.url.develop') : _this.$i18n.t('js.url.production');
        if(_jsURL != undefined) {
            _jsURL = url[0]+"//"+url[2]+"/"+_jsURL;
            _jsFolderName = _this.$i18n.t('js.name');
            if (!_jsURL.endsWith('/')) {
                _jsURL += '/';
            }
            $('head').append($('<script>').attr('type','text/javascript').attr('src',_jsURL + _jsFolderName + 'ninusi.js?t=' + _latest));
        }

        _faviconURL = (process.env.NODE_ENV === 'development') ? _this.$i18n.t('favicon.develop') : _this.$i18n.t('favicon.production');
        if(_faviconURL != undefined) {
            _faviconURL = url[0]+"//"+url[2]+"/"+_faviconURL;
            if (!_faviconURL.endsWith('/')) {
                _faviconURL += '/';
            }
            _this.faviconURL = _faviconURL + "favicon.ico";
        }

        $(function(){
            var ua = navigator.userAgent;
            var viewportMeta = $('meta[name="viewport"]');
            if (viewportMeta.length > 0) {
                viewportMeta.attr('content', 'width=device-width,initial-scale=1');
            }
        });

        EventBus.$on('error-httpStatus', function (httpStatus) {
            if (httpStatus.status == 401 && httpStatus.errorCode == 'ec001') {
                // セッション切れ
                // _this.$router.push( {name: 'SessionError', params: { messageError: httpStatus.message ,seconds: httpStatus.path}} );
                
                _this.site = _this.$router.history.current.fullPath.split("/")[1];
                common.removeLocalStorageEcSite(_this.site);
                location.href = httpStatus.path;
            } else if (httpStatus.status == 401 && httpStatus.errorCode == 'ec002') {
                // メンテナンス
                _this.$router.push( {name: 'Mente', params: { messageError: httpStatus.message }} );
            } else if (httpStatus.status == 401 && httpStatus.errorCode == 'ec003') {
                // アクセス制限
                _this.$router.push( {name: 'LimitUserAccess',  params: { messageError: httpStatus.message } });
            }  else if (httpStatus.status == 401 && httpStatus.errorCode == 'ec009') {
                //セッション切れ
                _this.site = _this.$router.history.current.fullPath.split("/")[1];
                common.removeLocalStorageEcSite(_this.site);
                _this.alertSessionMes.nextUrl = httpStatus.path
                _this.alertSessionMes.message = httpStatus.message
                _this.alertSessionMes.showMes = true
            } else if (httpStatus.status == 401 && httpStatus.errorCode == 'ec018') {
                // ログイン画面へ
                _this.$router.push({ name: SiteConstants.PG010MAIN, query: { pageNo: 18}});
            } else if (httpStatus.status == 401 && httpStatus.errorCode == 'ec073') {
                // BtoBログイン画面へ
                _this.$router.push({ name: SiteConstants.PG010MAIN, query: { pageNo: 18}});
            } else if (httpStatus.status == 404) {
                // Forward to 404
                _this.$router.push({ name: 'NotFound'});
            }  else {
                // エラーページへ
                _this.$router.push( {name: 'ErrorPage'} );
            }
        });
    },
    created: function(){
        var _this = this;
        var queryData = _this.$route.query;
        var params = _this.$route.params;
        if(Object.keys(queryData).length > 0){
            _this.pg010MainRequest = Object.assign({}, _this.pg010MainRequest, queryData);
        }

        if(Object.keys(params).length > 0){
            _this.pg010MainRequest = Object.assign({}, _this.pg010MainRequest, params);
        }
        if (!_this.pg010MainRequest.pageNo){
            if (_this.pg010MainRequest.categoryCd){
                _this.pg010MainRequest.pageNo = 2;
            } else if (_this.pg010MainRequest.sItemNo){
                _this.pg010MainRequest.pageNo = 3;
            } else if (_this.pg010MainRequest.sItemNolP){
                _this.pg010MainRequest.pageNo = 5;
            } else {
                _this.pg010MainRequest.pageNo = 1;
            }
        }
    },
    methods:{
        doNextUrl(){
            this.alertSessionMes.showMes = false
            location.href = this.alertSessionMes.nextUrl
        }
    }
}
</script>
